
const GetCities = `
    query{
      cities {
        id
        name
        zoom
        center {
          latitude
          longitude
        }
        state {
          id
          code
          name
          country {
            id
            name
          }
        }
      }
    }
  `;


const CreateBooking2 = `
mutation CreateBooking2Mutation($createBooking2Input: CreateBooking2Input!) {
  createBooking2(input: $createBooking2Input) {
    priceChanged
    priceDifference
    totalPriceAfterTax
    booking {
      id
      sabreConfirmationId
      propertyConfirmationId
      faunaDocId
    }
  }
}
`;
 
 

const GetReservationDetails = `
  query GetReservationDetailsInput (
    $email: String!
    $propertyConfirmationId: String!
  ) {
    getReservationDetails (
      input: {
        email: $email
        propertyConfirmationId: $propertyConfirmationId
      }
    ) {
      response
    }
  }
`;

const CancelBooking = `
  mutation cancelBookingUsingTravolutionary($cancelBookingInput: CancelBookingTravolutionaryInput!) {
    cancelBookingUsingTravolutionary(input: $cancelBookingInput) {
      response
    }
  }
`;

const GetBookingDetails = `
  query GetBookingDetailsInput ($id: String) {
    getBookingDetails (input: {id: $id}) {
      id
      propertyId
      paymentIntentId
      cardId
      sabreConfirmationId
      propertyConfirmationId
      faunaDocId
      firstName
      lastName
      email
      mobileNumber
      mobileCountryCallingCode
      checkInAtLocal
      checkOutAtLocal
      deadlineLocal
      data
      captured
      cancellationFeePrice
      intentType
      setupIntentObject
      customerId
      reservationStatus
    }
  }
`;

const ModifyBookingDetails = `
  mutation ModifyBooking  (
    $cancelBookingInput: CancelBookingInput!
    $createBooking2Input: CreateBooking2Input!
  ) {
    cancelBooking(input: $cancelBookingInput) {
      status
    }

    createBooking2(input: $createBooking2Input) {
      priceChanged
      priceDifference
      totalPriceAfterTax
      booking {
        id
        sabreConfirmationId
        propertyConfirmationId
        faunaDocId
      }
    }
  }
`;
 

const GetHomePageProperty = `
  query GetHomePagePropertiesThree {
    getHomepagePropertiesThree {
      hotelName
      fullAddressLine
      alias
      description
      petPolicyDescription
      amenities
      lat
      lng
      images
      petsAllowed
      petFee
      petFeeValue
      petFeeDetail
      petSize
      petAllowance
      unattendedPets
      petAmenities
      petReliefArea
      catPolicy
      starRating
      numberOfReviews
      travolutionaryId
      city
      state
      hotelRating
    }
  }
`;

 

const UserProfile = `
  query(
    $email: String!
    $id: String
  ) {
    getUserProfile(input: {
      email: $email, 
      id: $id
    }) {
      email
      name
      createdAt
      membershipId
      qualifyingNightsCount
      location
      address
      city
      state
      zip
      phone
      dob
      pets {
        id
        petName
        petDescription
        breedType
        weight
        dob
        preferences
        favoriteLocations
        allergies
        favoriteTreats
        images
      }
    }
  }
`;

/* Begin Listings Page Queries */
interface GetHotelsByLocationParamsType {
  adults: number | any;
  checkIn: number;
  checkOut: number;
  children: number;
  latitude: number;
  longitude: number;
  maxWaitInSeconds: number;
  hotelIds?: Array<any>;
}

// Longer timeout, to get a full list of hotels.
const GetHotelsByLocation = (params: GetHotelsByLocationParamsType) => {
  const {
    adults,
    checkIn,
    checkOut,
    children,
    latitude,
    longitude,
    maxWaitInSeconds,
    hotelIds = [],
  } = params;
  return `query {
      getHotels(input: {
        adults: ${adults},
        checkInDate: "${checkIn}",
        checkOutDate: "${checkOut}",
        children: "${children}",
        latitude: "${latitude}",
        longitude: "${longitude}",
        maxWaitInSeconds: ${maxWaitInSeconds},
        hotelIds: "${hotelIds}"
      }) {
        sessionId
        hotels {
          ID
          Address 
          DefaultImage
          DisplayName
          GeoLocation
          StarRating
          SuppliersLowestPackagePrices
          Packages
          hotelName
          description
          petsAllowed
          petFee
          petFeeValue
          petFeeDetail
          petSize
          petAllowance
          petBowls
          petBeds
          unattendedPets
          petAmenities
          petReliefArea
          catPolicy
          starRating
          numberOfReviews
          city
          state
          zipcode
          amenities
          alias
          images
          addressLine
          taxRate
          travoTaxRate
          extraFees
          pricelineAmenities
          hotelRating
          free_parking
          finalAmenities
          secondaryPropertyType
          tripAdvisorId
        }
      }
    }`;
};
/* End Listings Page Queries */
 
export {
  GetCities,    
  CreateBooking2,  
  GetReservationDetails,
  CancelBooking,
  GetBookingDetails,
  ModifyBookingDetails, 
  GetHomePageProperty,
  UserProfile, 

  //v2 
  GetHotelsByLocation,      
};
